import loadAuthenticationModule from './modules/Authentication.module';
import loadSessionModule from './modules/Session.module';
import loadBasketModule from './modules/Basket.module';
import loadCheckoutModule from './modules/Checkout.module';
const loadCheckoutConfirmationModule = () => ({
    hasRouter: true,
    modules: [loadSessionModule(), loadAuthenticationModule(), loadBasketModule(), loadCheckoutModule()],
});
export default loadCheckoutConfirmationModule;
